import { unescape } from 'lodash-es';
var iframeSrcRegex = /<iframe.*?src="(.*?)"/;
export default function getEmbedUrl(embed) {
    var match = iframeSrcRegex.exec(embed);
    if (match) {
        return unescape(match[1]);
    }
    return undefined;
}
